import ReactDOM from "react-dom";

// 获取当前元素到页面底部的距离
export function getOffsetHeight(dom) {
    if (dom) {
        let DomNode = ReactDOM.findDOMNode(dom);
        let offsetHeight = DomNode?.offsetHeight;
        if(offsetHeight) {
            return offsetHeight
        }
    }
    return 0
}

export function getMaxWidth(otherWidth=0) {
    let clientWidth = window.document.body.clientWidth;
    return clientWidth - getPageMargin()*2 - getAntTreeWidth() - otherWidth
};

// 获取左侧tree宽度
function getAntTreeWidth() {
    // 页面整体刷新时无法保证左侧树比右侧内容先渲染出来，临时默认显示左侧树
    return 240
    let antTree = document.getElementsByClassName("ant-tree");
    if(antTree?.length) {
        return 240
    }
    return 0
};

// 获取页面两端的外边距
function getPageMargin() {
    let clientWidth = window.document.body.clientWidth;
    let contentMarginScopeDefault = '[{"expression":">=1900","value":"140"},{"expression":"<1900","value":"40"}]';
    let contentMarginScope = window.sysConfigGetValueByKey("system.content.margin.scope", contentMarginScopeDefault);
    contentMarginScope = JSON.parse(contentMarginScope);
    let contentMarginValue = 40;
    for(let i = 0; i < contentMarginScope.length; i++){
        let contentMargin = contentMarginScope[i];
        let isTrue = eval(clientWidth + contentMargin.expression);
        if(isTrue){
            contentMarginValue = parseInt(contentMargin.value);
            break;
        }
    }
    return contentMarginValue
};

export function checkWidth(col,marginRight=24,otherW=0) {
    let data = {marginRight:marginRight,scale:1};
    if(col?.length) {
        let width = 0;
        let marginW = (col.length-1) * marginRight;
        let marginM = col.length * 5;
        col.forEach(item=>{
            let w = item?.component?.config?.style?.width || 0;
            width=width+w
        });
        let maxWidth = getMaxWidth(otherW);
        if(maxWidth < (width+marginW)) {
            if(maxWidth < (width+marginM)) {
                data.marginRight = 5;
            } else {
                data.marginRight = (maxWidth-width)/col.length
            }
        }
    }
    return data
}

